<template>
  <div class="card">
    <section class="eb-cart-summary-section">
      <div class="eb-cart-count-section">
        <span class="eb-cart-count">
          <span class="count-number">{{ formatNumber(totalCount) }}</span> {{ totalCountText }}
        </span>
        <div
          v-if="showOneCostFirm && totalCount > 0"
          class="cost-per-firm"
        >
          <span>
            1 компания - {{ getOneFirmCost }} руб.
          </span>
        </div>
      </div>

      <div class="eb-cart-total-section">
        <div class="eb-cart-total-cost">
          <div class="eb-cart-label">
            Итого:
          </div>
          <span
            class="eb-cart-cost"
            :class="classesForCost"
          >
            {{ totalCostText }} руб.
            <span
              v-if="visibleDiscount > 0"
              class="discount-info"
            >
              <span class="original-price">
                {{ formatNumber(Math.round(totalCost / (1 - visibleDiscount/100))) }} руб.
              </span>
              <span class="discount-percent">
                -{{ visibleDiscount }}%
              </span>
            </span>
          </span>
        </div>
        <div class="eb-cart-total-wrapper">
          <div
            v-if="!isSubscriptionMode"
            class="benefits-section"
          >
            <div
              v-if="balanceBonusNotice && totalCount > 0"
              class="bonus-link _popup"
              data-file="/api/popup/bonus_for_paid_order"
              data-method="GET"
              @click="balanceYandexGoalHandler"
            >
              <span
                v-if="bonusValue > 0"
                class="bonus-with-value"
              >
                {{ bonusValue }}р. кешбэк на баланс
              </span>
              <span v-else>
                + бонусы на баланс
              </span>
              <img
                class="help_img"
                src="/dist/css/images/exp_question.png"
                alt="Бонус за оплату заказа"
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="notifications_section">
      <slot name="notifications" />
    </section>

    <section class="eb-cart-buttons-section">
      <span
        v-if="isSubscriptionMode"
        key="subscription"
        class="eb-button-basket button-subscription"
        @click="subscriptionButtonClick"
      >
        Оформить подписку
      </span>

      <template v-else>
        <span
          key="demo"
          class="eb-button-basket button-demo"
          @click="demoClick"
        >
          Скачать демо
        </span>

        <span
          key="pay"
          class="eb-button-basket button-pay"
          :class="{'disabled' : !totalCost}"
          @click="downloadButtonClick"
        >
          Оплатить
        </span>
      </template>
    </section>
  </div>
</template>

<script>
import numeralize from 'numeralize-ru';

export default {
  name: 'SummaryBasket',
  props: {
    totalCost: {
      type: Number,
      required: true,
    },

    totalCount: {
      type: Number,
      required: true,
    },

    visibleDiscount: {
      type: Number,
      default: 0,
    },

    balanceBonusNotice: {
      type: Boolean,
      default: false,
    },

    bonusValue: {
      type: Number,
      required: false,
      default: 0,
    },

    isSubscriptionMode: {
      type: Boolean,
      required: false,
    },

    subscriptionDeposit: {
      type: Number,
      required: false,
      default: 0,
    },

    isSubscriptionModeBalanceOnly: {
      type: Boolean,
      default: false,
    },

    balance: {
      type: Number,
      required: false,
      default: 0,
    },

    showOneCostFirm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ['demoClick', 'downloadButtonClick', 'subscriptionButtonClick'],

  computed: {
    totalCostText() {
      if (
        this.isSubscriptionMode
          && this.isSubscriptionModeBalanceOnly
      ) {
        return `Баланс: ${this.formatNumber(this.balance)}`;
      }

      if (this.isSubscriptionMode) {
        return this.formatNumber(this.subscriptionDeposit);
      }

      return this.formatNumber(this.totalCost);
    },

    getTotalCost() {
      if (
        this.isSubscriptionMode
          && this.isSubscriptionModeBalanceOnly
      ) {
        return this.balance;
      }

      if (this.isSubscriptionMode) {
        return this.subscriptionDeposit;
      }

      return this.totalCost;
    },

    classesForCost() {
      return {
        'eb-cart-cost-warn': (this.totalCost === 0),
      };
    },

    totalCountText() {
      if (this.isSubscriptionMode) {
        return numeralize.pluralize(this.totalCount, 'компанию', 'компании', 'компаний');
      }
      return numeralize.pluralize(this.totalCount, 'компания', 'компании', 'компаний');
    },

    subscriptionDisabled() {
      return (this.subscriptionDeposit === 0);
    },

    getOneFirmCost() {
      return (this.getTotalCost / (this.totalCount || 1)).toFixed(2);
    },
  },

  methods: {
    balanceYandexGoalHandler() {
      if (window.MFuncs && window.MFuncs.yandexReachGoalWithTarget) {
        window.MFuncs.yandexReachGoalWithTarget('detail_sale');
      }
    },

    demoClick() {
      this.$emit('demoClick');
    },

    downloadButtonClick() {
      this.$emit('downloadButtonClick');
    },

    subscriptionButtonClick() {
      if (this.subscriptionDisabled) {
        window.echo('Нельзя оплатить заказ на 0 руб.');
      } else {
        this.$emit('subscriptionButtonClick');
      }
    },

    formatNumber(n) {
      return Number(n).toLocaleString(['ru', 'en']);
    },
  },
};
</script>

<style scoped>
.card {
  box-sizing: border-box;
  width: 390px;
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
}

.eb-cart-summary-section {
  display: flex;
  justify-content: space-between;
}

.eb-cart-count-section {
  margin-bottom: 15px;
}

.eb-cart-count {
  color: #333;
  font-size: 16px;
}

.cost-per-firm {
  margin-top: 5px;
  font-size: 14px;
  color: #666;
}

.eb-cart-total-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}

.eb-cart-total-cost {
  display: flex;
  gap: 10px;
}

.eb-cart-label {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.eb-cart-total-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.eb-cart-cost-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.eb-cart-cost {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  padding: 12px;
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid  var(--color-button-prime);
}

.eb-cart-cost-warn {
  color: #999;
  border-color: #999;
}

.discount-info {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: 14px;
}

.original-price {
  color: #999;
  text-decoration: line-through;
  margin-right: 5px;
}

.discount-percent {
  color:  var(--color-button-prime);
  font-weight: bold;
  margin-right: 5px;
}

.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #eee;
  color: #666;
  font-size: 12px;
  cursor: pointer;
}

.benefits-section {
  margin-top: 8px;
}

.bonus-link {
  cursor: pointer;
  font-size: 14px;
  color: var(--color-button-prime);
  text-decoration: 1px solid  var(--color-button-prime);
}

.bonus-with-value {
  color: var(--color-button-prime);
  font-size: 14px;
}

.eb-cart-buttons-section {
  position: relative;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.eb-button-basket {
  width: 130px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 35px;
  border: none;
  border-radius: 5px;
  transition: .15s;
  font-size: 16px;
  cursor: pointer;
  color: white;
  background: var(--color-button-prime);
  box-shadow: none;
}

.button-demo {
  background-color: transparent;
  border: 1px solid var(--color-button-prime);
  color: var(--color-button-prime);
}

.button-pay {
  background-color: var(--color-button-prime);
  border: none;
  color: white;
}

.button-pay:hover {
  background-color:  var(--color-button-prime);
}

.button-pay.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.button-subscription {
  background-color: #6ca82b;
  border: none;
  color: white;
  margin: 0 auto;
  width: 250px;
}

.count-number {
  font-weight: bold;
}

.help_img {
  margin-left: 3px;
  top: 3px;
  position: relative;
}
</style>
